/*
  NUDIENT: Cookierutan först, M-169. Utredning:
  nudient/UTREDNING-V14-cookieruta.md.

  Följer Pandectes cookieruta, <dialog> inuti komponenten pandectes-cmp.
  Så länge den syns har <html> attributet data-nudient-consent-open och
  variabeln --nudient-consent-height med rutans höjd. När kunden har svarat
  och rutan stängs tas båda bort.

  - assets/nudient-tokens.css håller Klaviyos registreringsruta, popupen
    "NUDIENT sign-up 15% (new customers)", dold medan attributet finns, så
    att kunden får en ruta i taget, V14. Regeln bygger på Klaviyos egen
    uppbyggnad, role="dialog" och aria-label="POPUP Form". Ändrar Klaviyo
    den träffar regeln inget, och rutan visas som vanligt. Den kan aldrig
    försvinna helt: utan attributet, eller om Pandectes inte finns, gäller
    ingen regel. Kontrollpunkt U4 i nudient/HORIZON-ANDRINGAR.md.
  - assets/nudient-hero.css lyfter hjältens ruta med modellväljaren med
    rutans höjd från 768, så att knappen inte täcks.

  Pandectes och Klaviyo ändras inte. Skriptet läser bara Pandectes ruta.

  Värden som inte är tokens:
  - pandectes-cmp och dialog: Pandectes komponent och ruta.
  - data-nudient-consent-open och --nudient-consent-height: kopplingen till
    stilarna.
  - 500 och 60: skriptet letar efter Pandectes ruta var 500:e millisekund i
    högst 30 sekunder.
*/

const root = document.documentElement;
let watchedDialog = null;
let resize = null;

function update() {
  const host = document.querySelector('pandectes-cmp');
  const dialog = host?.shadowRoot?.querySelector('dialog') || null;
  let open = false;
  let height = 0;
  if (dialog) {
    const box = dialog.getBoundingClientRect();
    const style = getComputedStyle(dialog);
    open = box.height > 0 && style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
    height = box.height;
  }
  root.toggleAttribute('data-nudient-consent-open', open);
  if (open) root.style.setProperty('--nudient-consent-height', `${Math.round(height)}px`);
  else root.style.removeProperty('--nudient-consent-height');

  if (dialog !== watchedDialog) {
    resize?.disconnect();
    watchedDialog = dialog;
    if (dialog && 'ResizeObserver' in window) {
      resize = new ResizeObserver(update);
      resize.observe(dialog);
    }
  }
}

function watch(host) {
  if (!host.shadowRoot) return false;
  new MutationObserver(update).observe(host.shadowRoot, { subtree: true, childList: true, attributes: true });
  update();
  return true;
}

function start() {
  /* Pandectes sätter in komponenten och dess innehåll efter sidan, ibland i
     två steg: fråga var 500:e millisekund i högst 30 sekunder */
  let tries = 0;
  const timer = setInterval(() => {
    const host = document.querySelector('pandectes-cmp');
    if ((host && watch(host)) || ++tries >= 60) clearInterval(timer);
  }, 500);
}

window.addEventListener('resize', update);
if (document.body) start();
else document.addEventListener('DOMContentLoaded', start, { once: true });
